import { container } from '@client/core/container';
import { Axios } from 'axios';
import { User } from '@client/features/user/models/user';
import { JsonResponse } from '@client/core/http/types';
import { AuthorizedUploadIntent } from '@client/features/attachments/types';

// TODO: Inline this?
export interface AuthorizedUploadIntentOptions {
  workspaceOwnerId: User['id'];
  filename: string; // Such as "front-of-house.jpg"
  fileChecksum: string; // SHA-256
  fileContentType: string | null; // Such as "image/jpeg"
  fileSize: number;
}

/**
 * Get details about the HTTP Request the web client should call to upload a
 * Photo Log Photo.
 *
 * The backend saves error/validation details to the Intent if validation fails.
 */
export async function getUploadIntent(opts: AuthorizedUploadIntentOptions): Promise<AuthorizedUploadIntent> {
  const api = container(Axios);

  const payload = {
    filename: opts.filename,
    checksum: opts.fileChecksum,
    mimeType: opts.fileContentType || 'application/octet-stream',
    size: opts.fileSize,
  };

  const response = await api.post<JsonResponse<AuthorizedUploadIntent>>(
    `/workspace/${opts.workspaceOwnerId}/upload-intent`,
    payload,
  );

  return response.data.data;
}
